.root {
  overflow: hidden;
}

.splitter {
  position: relative;
  display: flex;
  flex: 1;
  overflow: auto;
}

.trackLane {
  display: flex;
}
